import React, { Component } from 'react';
import { connect } from 'react-redux';

import { deleteAttachmentCreator } from 'creators/attachments';
import { runUploadQueue } from 'utilities/attachments';

import errorIcon from 'img/icons/attachment-upload/error.svg';
import successIcon from 'img/icons/attachment-upload/success.svg';
import syncIcon from 'img/icons/attachment-upload/sync.svg';

import './styles.less';

class AttachmentUploadProgressModal extends Component {
  render() {
    const {
      currentJobIndex,
      currentJobName,
      error,
      totalJobs,
      uploadProgress,
    } = this.props;

    const action = error ? 'Error with' : 'Uploading';
    const itemProgress = ` (${currentJobIndex}/${totalJobs})`;
    const indicator = `${action} ${currentJobName}`;

    let icon;
    let classState = '';
    let reuploadAction = null;
    let cancelAction = (
      <span className="cancel" onClick={this.handleCancel}>
        &times;
      </span>
    );

    const progressStyle = { width: '100%' };

    if (error) {
      icon = errorIcon;
      classState = 'error';
      reuploadAction = (
        <span className="retry" onClick={this.handleRetry}>
          Re-Upload
        </span>
      );
    } else if (uploadProgress === 1) {
      icon = successIcon;
      classState = 'success';
      cancelAction = null;
    } else {
      icon = syncIcon;
      progressStyle.width = `${uploadProgress * 100}%`;
    }

    return (
      <div className={`attachment-upload-progress-modal ${classState}`}>
        <div className="wrapper">
          <div className="content">
            <img src={icon} />
            <div className="indicator">
              <span>{indicator}</span>
              <span className="item-progress">{itemProgress}</span>
              {reuploadAction}
            </div>
            {cancelAction}
          </div>
          <span className="progress-bar" style={progressStyle} />
        </div>
      </div>
    );
  }

  handleCancel = () => {
    this.props.deleteAttachment(this.props.uploadQueue[0].id);
  };

  handleRetry = () => {
    runUploadQueue();
  };
}

const mapStateToProps = state => {
  const {
    upload_error,
    upload_progress: uploadProgress,
    upload_queue: uploadQueue,
    upload_queue_current_job_index: currentJobIndex,
    upload_queue_total_jobs: totalJobs,
  } = state.attachments;

  return {
    currentJobName: uploadQueue[0].name,
    error: upload_error,
    uploadProgress,
    uploadQueue,
    currentJobIndex,
    totalJobs,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteAttachment: attachmentId =>
      dispatch(deleteAttachmentCreator(attachmentId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttachmentUploadProgressModal);
